<template>
  <div :id="componentId" class="sp-seven-module-three">
    <!-- 月份定位 -->
    <div class="s7mo-month-position">
      <div class="s7mo-month-circle">
        <span class="s7mo-month-num">{{ currentMonthData.month || '5 月' }}</span>
        <span class="s7mo-month-char">月</span>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="s7mo-content" v-if="currentMonthData">
      <!-- 标题图片 -->
      <div class="s7mo-header-image-container">
        <img :src="mainImage" alt="" class="s7mo-header-image"/>
      </div>

      <!-- 标题区域 -->
      <div class="s7mo-title-container">
        <div class="s7mo-title-text">{{ title }}</div>
      </div>

      <!-- 新闻列表（三条并排） -->
      <div class="s7mo-news-list">
        <div
          class="s7mo-news-card"
          v-for="(news, index) in newsList"
          :key="index"
        >
          <!-- 品牌名称（左上） -->
          <div class="s7mo-brand-wrapper">
            <div class="s7mo-brand-bar"></div>
            <div class="s7mo-brand-name">{{ currentMonthData.brandName || '中国品牌' }}</div>
          </div>

          <!-- 图片 -->
          <div class="s7mo-image-box" v-if="news.newsImage">
            <a :href="getNewsDetailUrl(news.newsNo)" target="_blank" @click.stop class="s7mo-news-link">
              <img :src="news.newsImage" :alt="news.newsTitle" class="s7mo-news-image"/>
            </a>
          </div>

          <!-- 来源 / 时间 -->
          <div class="s7mo-footer">
            <span class="s7mo-source">{{ news.source.split('|')[0] || '中国品牌网' }}</span>
            <span class="s7mo-divider">|</span>
            <span class="s7mo-time">{{ formatRelativeTime(news.publishTime) || '4 小时前' }}</span>
          </div>

          <!-- 标题 -->
          <a :href="getNewsDetailUrl(news.newsNo)" target="_blank" @click.stop class="s7mo-news-title">{{ news.newsTitle }}</a>

          <!-- 摘要 -->
          <div class="s7mo-news-summary">{{ news.newsSummary }}</div>
        </div>
      </div>
    </div>

    <!-- 空状态提示 -->
    <div v-else class="s7mo-empty-tip">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: 'SpSevenModuleThree',
  props: {
    componentId: {
      type: String,
      default: 'sp_seven_module_three'
    },
    pageModules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: {
        month: '5',
        title: '会昌',
        mainImage: 'https://image.cbrand.com.cn/default/2026/09/EE92424018314B9E8358D523342D4CCF.png',
        brandName: '啃老鸭',
        newsInfo: [
          {
            newsNo: '',
            newsImage: 'https://image.cbrand.com.cn/default/2026/09/E6CE65EDB16046938CA4FC1BAE3DEE5F.png',
            newsTitle: '国际足联对奥克兰枪击案表示哀悼女足世界杯揭幕',
            newsSummary: '7 月 24 日，《关于进一步抓好抓实促进民间投资工作 努力调动民间投资积极性的通知》（下称"《通知》"）',
            source: '中国品牌网',
            publishTime: '2024-07-24 10:30:00'
          },
          {
            newsNo: '',
            newsImage: 'https://image.cbrand.com.cn/default/2026/09/E6CE65EDB16046938CA4FC1BAE3DEE5F.png',
            newsTitle: '国际足联对奥克兰枪击案表示哀悼女足世界杯揭幕',
            newsSummary: '7 月 24 日，《关于进一步抓好抓实促进民间投资工作 努力调动民间投资积极性的通知》（下称"《通知》"）',
            source: '中国品牌网',
            publishTime: '2024-07-24 10:30:00'
          },
          {
            newsNo: '',
            newsImage: 'https://image.cbrand.com.cn/default/2026/09/E6CE65EDB16046938CA4FC1BAE3DEE5F.png',
            newsTitle: '国际足联对奥克兰枪击案表示哀悼女足世界杯揭幕',
            newsSummary: '7 月 24 日，《关于进一步抓好抓实促进民间投资工作 努力调动民间投资积极性的通知》（下称"《通知》"）',
            source: '中国品牌网',
            publishTime: '2024-07-24 10:30:00'
          }
        ]
      }
    }
  },
  computed: {
    currentMonthData() {
      return this.data || {}
    },
    newsList() {
      return (this.currentMonthData.newsInfo || []).slice(0, 3)
    },
    mainImage() {
      return this.currentMonthData.mainImage || ''
    },
    title() {
      return this.currentMonthData.title || '会昌'
    }
  },
  methods: {
    formatRelativeTime(time) {
      if (!time) return ''
      let date = new Date(time)
      const now = new Date()
      const diffMs = now - date
      const diffMinutes = Math.floor(diffMs / 60000)
      const diffHours = Math.floor(diffMs / 3600000)
      const diffDays = Math.floor(diffMs / 86400000)
      
      if (diffMinutes < 1) {
        return '刚刚'
      } else if (diffMinutes < 60) {
        return diffMinutes + '分钟前'
      } else if (diffHours < 24) {
        return diffHours + '小时前'
      } else {
        return diffDays + '天前'
      }
    },
    getNewsDetailUrl(newsNo) {
      if (!newsNo) return '#'
      return `/zp/a/${newsNo}.html`
    }
  }
}
</script>

<style scoped>
.sp-seven-module-three {
  position: relative;
  width: 1400px;
  min-width: 1400px;
  max-width: 1400px;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 0;
  height: 764px;
}

/* 月份定位 */
.s7mo-month-position {
  position: absolute;
  left: 48px;
  z-index: 10;
}

.s7mo-month-circle {
  width: 104px;
  height: 95px;
  background: url('./images/month-bg.png') no-repeat center center;
  background-size: cover;
  border-radius: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 1.2;
}

/* 月份数字 */
.s7mo-month-num {
  font-size: 40px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  margin-right: 2px;
  margin-bottom: 7px;
}

/* 月字 */
.s7mo-month-char {
  font-size: 26px;
  font-family: Microsoft YaHei, Microsoft YaHei;
}

.s7mo-content {
  position: relative;
  width: 100%;
  height: 524px;
}

/* 标题图片 */
.s7mo-header-image-container {
  position: absolute;
  left: 173px;
  top: 24px;
  width: 1227px;
  height: 340px;
  overflow: hidden;
}

.s7mo-header-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 标题区域 */
.s7mo-title-container {
  position: absolute;
  left: 173px;
  top: 47px;
  width: 713px;
  height: 82px;
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
  z-index: 2;
}

.s7mo-title-text {
  position: absolute;
  left: 0;
  margin-top: 21px;
  margin-left: 21px;
  width: 136px;
  height: 67px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 50px;
  color: #000000;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/* ===== 新闻列表容器：三条卡片并排 ===== */
.s7mo-news-list {
  position: absolute;
  left: 205px;
  margin-top: 244px;
  width: 1160px;
  height: 478px;
  display: flex;
  gap: 70px;
}

/* 每个新闻卡片独立成块 */
.s7mo-news-card {
  position: relative;
  width: 340px;
  height: 478px;
  padding: 20px 25px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(238,244,252,1) 0%, rgba(244,249,255,1) 100%),
              linear-gradient(180deg, rgba(247,248,251,1) 0%, rgba(251,253,253,1) 100%);
  border-radius: 10px;
  overflow: hidden;
}

/* 品牌名称和竖杆 */
.s7mo-brand-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: -11px;
}

.s7mo-brand-bar {
  width: 8px;
  height: 34px;
  background-color: #333333;
  background-image: url('./images/shu.png');
  flex-shrink: 0;
  border-radius: 5px;
}

.s7mo-brand-name {
  width: 196px;
  height: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: left;
}

/* 图片 */
.s7mo-image-box {
  width: 340px;
  height: 190px;
  overflow: hidden;
  margin-top: 15px;
  margin-left: -25px;
}

.s7mo-news-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.s7mo-news-link:hover .s7mo-news-image {
  transform: scale(1.05);
}

/* 来源 / 时间 */
.s7mo-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666666;
  margin-top: 15px;
}

.s7mo-source,
.s7mo-divider,
.s7mo-time {
  font-family: Microsoft YaHei, Microsoft YaHei;
  text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 118px;
    overflow: hidden;
}

/* 标题 */
.s7mo-news-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  line-height: 1.5;
  margin-top: 10px;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.s7mo-news-title:hover {
  color: #008A44;
}

/* 摘要 */
.s7mo-news-summary {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.s7mo-empty-tip {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 50%;
  font-size: 14px;
  color: #999;
}
</style>
